import React, { useState, useEffect } from "react";
import { TimeZoneWithCountryDropdown } from "components";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { projectType } from "utils/lookUpTable";
import SC from "./style";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { Button } from "@InnoUI/";
import theme from "@theme/";
import { isEmpty, isValidFolderId } from "utils/helper";

const OccupantFilterDropdown = () => {
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [searchInput, setSearchInput] = useState(""); // Add search input state
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const type = searchParams.get("type");
  const folderId = searchParams.get("folderId");
  const navigate = useNavigate();
  const currentProject = useSelector(
    (state) => state?.currentProject?.data || null
  );

  const occupantOption = useSelector((state) =>
    Array.isArray(state?.occupantOption?.data)
      ? state?.occupantOption?.data
      : []
  );
  const isOccupantOptionFetching = useSelector(
    (state) => state?.occupantOption?.isFetching || false
  );

  const numberOption = occupantOption
    .map((option) => ({
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span
            style={{
              fontWeight: "600",
              color: "#374151",
              fontSize: "14px",
            }}
          >
            {option?.occupantName}
          </span>
          <span
            style={{
              fontWeight: "400",
              color: "#6b7280",
              fontSize: "12px",
              backgroundColor: "#f3f4f6",
              padding: "2px 6px",
              borderRadius: "4px",
              marginLeft: "8px",
            }}
          >
            #{option?.occupantNo}
          </span>
        </div>
      ),
      children: `${option?.occupantName} ${option?.occupantNo}`, // Searchable text for filtering
      value: option?.id,
    }))
    .sort((a, b) => a.children.localeCompare(b.children));

  const handleNumberChange = (value) => {
    setSelectedNumber(value);
  };

  // Navigate when number is selected
  useEffect(() => {
    if (selectedNumber) {
      const selectedOccupant = occupantOption.find(
        (option) => option.id == selectedNumber
      );

      if (selectedOccupant) {
        navigate(
          `/project-home/occupanthomepage?projectId=${selectedOccupant.id}&type=${projectType.occupant}`
        );
      }
    }
  }, [selectedNumber]);

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter" && searchInput.trim() !== "") {
      const targetProjectId = !isEmpty(projectId)
        ? projectId
        : currentProject?.id;
      if (!targetProjectId) return;

      const params = new URLSearchParams({
        projectId: String(targetProjectId),
        searchKey: searchInput.trim(),
        type: !isEmpty(type) ? type : String(projectType.property),
      });

      if (isValidFolderId(folderId)) {
        params.set("folderId", folderId);
      }

      navigate(`/project-home/documentsearch?${params.toString()}`);
    }
  };

  return (
    <>
      {SC.Globalstyles}

      <SC.Contaiiner className="occupant-filter-dropdown">
        <SC.InputContiner>
          <TimeZoneWithCountryDropdown
            placeholder="Search occupant"
            options={numberOption}
            value={selectedNumber}
            onChange={handleNumberChange}
            width="100%"
            height="40px"
            allowClear={true}
            loading={isOccupantOptionFetching}
            virtual={false}
            popupClassName="occupant-filter-options-dropdown"
            dropdownStyle={{
              maxHeight: "320px",
              overflowY: "auto",
              padding: "8px 0 10px",
            }}
            notFoundContent={
              isOccupantOptionFetching ? "Loading occupants..." : "No data"
            }
            filterOption={(input, option) => {
              const searchText = option.children || "";
              return searchText.toLowerCase().includes(input.toLowerCase());
            }}
          />
        </SC.InputContiner>

        {/* <SC.InputContiner>
          <SC.InputStyle
            placeholder={"Search keywords for files"}
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyDown={handleSearchKeyDown}
          />
          <SC.SearchIconContainer
            onClick={() => {
              if (searchInput.trim() !== "") {
                navigate(
                  `/project-home/documentsearch?projectId=${projectId}&searchKey=${searchInput.trim()}&type=${type}&folderId=${folderId}`
                );
              }
            }}
          >
            <SC.SearchIcon />
          </SC.SearchIconContainer>
        </SC.InputContiner> */}
        <Button
          caption={"Search"}
          type="submit"
          color="white"
          onClick={() => {
            const targetProjectId = !isEmpty(projectId)
              ? projectId
              : currentProject?.id;
            if (!targetProjectId) return;

            const params = new URLSearchParams({
              projectId: String(targetProjectId),
              type: !isEmpty(type) ? type : String(projectType.property),
            });

            if (isValidFolderId(folderId)) {
              params.set("folderId", folderId);
            }

            navigate(`/project-home/advancedsearch?${params.toString()}`);
          }}
          fontSize="12px"
          style={{
            background: theme.gradient.themeGradient,
            color: theme.colors.white,
            minWidth: "100px",
            height: "30px",
            borderRadius: "3px",
          }}
        />
      </SC.Contaiiner>
    </>
  );
};

export default OccupantFilterDropdown;
